var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServiceTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#00AC97",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 11.5V20.5",
    stroke: "#00AC97",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50001 18.45C9.49937 18.3348 9.539 18.2231 9.61204 18.1341C9.68509 18.0451 9.78695 17.9844 9.90001 17.9625C10.3497 17.867 10.753 17.62 11.0423 17.2627C11.3317 16.9055 11.4896 16.4597 11.4896 16C11.4896 15.5403 11.3317 15.0945 11.0423 14.7373C10.753 14.38 10.3497 14.133 9.90001 14.0375C9.78695 14.0156 9.68509 13.9549 9.61204 13.8659C9.539 13.7769 9.49937 13.6652 9.50001 13.55V12C9.50001 11.8674 9.55269 11.7402 9.64645 11.6464C9.74022 11.5527 9.8674 11.5 10 11.5H22C22.1326 11.5 22.2598 11.5527 22.3536 11.6464C22.4473 11.7402 22.5 11.8674 22.5 12V13.55C22.5006 13.6652 22.461 13.7769 22.388 13.8659C22.3149 13.9549 22.2131 14.0156 22.1 14.0375C21.6503 14.133 21.247 14.38 20.9577 14.7373C20.6683 15.0945 20.5105 15.5403 20.5105 16C20.5105 16.4597 20.6683 16.9055 20.9577 17.2627C21.247 17.62 21.6503 17.867 22.1 17.9625C22.2131 17.9844 22.3149 18.0451 22.388 18.1341C22.461 18.2231 22.5006 18.3348 22.5 18.45V20C22.5 20.1326 22.4473 20.2598 22.3536 20.3536C22.2598 20.4473 22.1326 20.5 22 20.5H10C9.8674 20.5 9.74022 20.4473 9.64645 20.3536C9.55269 20.2598 9.50001 20.1326 9.50001 20V18.45Z",
    stroke: "#00AC97",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceTicket);
export default __webpack_public_path__ + "static/media/service_ticket.e112a756f7eb9e76b97d91b690043c1c.svg";
export { ForwardRef as ReactComponent };